export default "__VITE_ASSET__CLT83VE8__"